import { LayoutGrid } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import { getAdminAccess } from './adminAccess'
import { ADMIN_TOOLS } from './adminTools'

const baseClass =
  'flex h-9 items-center gap-2 rounded-lg border px-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20'

export default function AdminToolNav() {
  const { t } = useTranslation('pages')
  const { user } = useAuth()
  const access = getAdminAccess(user)
  const visibleTools = ADMIN_TOOLS.filter((tool) => access[tool.id])

  return (
    <nav
      aria-label={t('adminHub.navigationLabel')}
      className="mb-8 flex flex-wrap gap-2 border-b border-border-subtle pb-4"
      data-testid="admin-tool-nav"
    >
      <NavLink
        to="/admin"
        end
        className={({ isActive }) =>
          `${baseClass} ${
            isActive
              ? 'border-primary/50 bg-primary/10 text-primary'
              : 'border-input-border bg-surface-1 text-muted-foreground hover:border-input-border-hover hover:bg-surface-3 hover:text-foreground'
          }`
        }
      >
        <LayoutGrid className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
        {t('adminHub.overview')}
      </NavLink>

      {visibleTools.map((tool) => {
        const Icon = tool.icon
        return (
          <NavLink
            key={tool.id}
            to={tool.href}
            className={({ isActive }) =>
              `${baseClass} ${
                isActive
                  ? 'border-primary/50 bg-primary/10 text-primary'
                  : 'border-input-border bg-surface-1 text-muted-foreground hover:border-input-border-hover hover:bg-surface-3 hover:text-foreground'
              }`
            }
          >
            <Icon className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
            {t(tool.titleKey)}
          </NavLink>
        )
      })}
    </nav>
  )
}
